import { http } from '../../config/axios'

export default function ativarPerfil(idPerfil: string): Promise<string> {
  return http
    .patch('api/perfil/ativar/' + idPerfil)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro ativarPerfil', error)
      throw Error(error.response.data)
    })
}
